import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule, UtilsModule } from '@mtgame/ui';
import { StatisticTableGroupedComponent } from './statistic-table-grouped.component';
import { SharedModule } from '@shared/shared.module';
import { StatisticTableModule } from '../statistic-table/statistic-table.module';
import { HockeyStatisticTableGroupedComponent } from './hockey-statistic-table-grouped.component';
import { FootballStatisticTableGroupedComponent } from './football-statistic-table-grouped.component';
import { HandballStatisticTableGroupedComponent } from './handball-statistic-table-grouped.component';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    UtilsModule,
    RouterModule,
    SharedModule,
    StatisticTableModule
  ],
  declarations: [
    StatisticTableGroupedComponent,
    HockeyStatisticTableGroupedComponent,
    FootballStatisticTableGroupedComponent,
    HandballStatisticTableGroupedComponent,
  ],
  exports: [
    StatisticTableGroupedComponent,
    HockeyStatisticTableGroupedComponent,
    FootballStatisticTableGroupedComponent,
    HandballStatisticTableGroupedComponent,
  ]
})
export class StatisticTableGroupedModule {}
